import { useState } from "react";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";

const PRESETS = [["XXS", "XS", "S", "M", "L", "XL"], ["36", "38", "40", "42", "44", "46"], ["Taglia Unica"]];

export const SizesInput = ({ value = [], onChange }) => {
  const [txt, setTxt] = useState("");
  const add = () => {
    const v = txt.trim().toUpperCase();
    if (v && !value.includes(v)) onChange([...value, v]);
    setTxt("");
  };
  return (
    <div className="space-y-2" data-testid="sheet-sizes">
      <div className="flex flex-wrap items-center gap-1.5">
        {value.map((z) => (
          <span key={z} className="flex items-center gap-1 rounded-md border border-border bg-secondary/50 px-2 py-1 text-xs font-medium" data-testid={`sheet-size-${z}`}>
            {z}<button type="button" onClick={() => onChange(value.filter((x) => x !== z))} aria-label={`Rimuovi ${z}`}><X className="h-3 w-3" /></button>
          </span>
        ))}
        <Input value={txt} onChange={(e) => setTxt(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }} onBlur={add}
          placeholder="Aggiungi taglia e premi Invio" className="h-8 w-48 text-xs" data-testid="sheet-size-input" />
      </div>
      <div className="flex flex-wrap gap-1.5">
        {PRESETS.map((p) => (
          <button key={p.join()} type="button" onClick={() => onChange(p)} className="rounded border border-dashed border-border px-2 py-0.5 text-[11px] text-muted-foreground hover:border-primary hover:text-primary">
            {p.join(" ")}
          </button>
        ))}
      </div>
    </div>
  );
};
